import { IntegratedSummary } from "@devexpress/dx-react-grid";

const confTableSummaryMessages = {
  count: "Nº",
  sum: "Total",
  intSum: "Total",
  floatSum: "Total",
  brCurrencySum: "Total",
  brCurrencyMean: "Média",
};

const convertNumber = (number) => {
  let result = number;
  if (isNaN(result)) {
    result = parseFloat(result);
  }
  if (isNaN(result)) {
    result = 0;
  }
  return result;
};

const confTableSummaryCalculator = (type, rows, getValue) => {
  const shouldFilter =
    rows.length > 0 && rows.every((row) => "relationshipType" in row);

  const filteredRows = shouldFilter
    ? rows.filter((row) => row.relationshipType === "Cliente")
    : rows;

  if (type === "brCurrencySum") {
    if (!filteredRows.length) {
      return null;
    }
    const sum = filteredRows.reduce((acc, row) => {
      let number = getValue(row);
      if (number) {
        number = convertNumber(number);
        return acc + number;
      }
      return acc;
    }, 0);
    return sum.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }
  if (type === "brCurrencyMean") {
    if (!filteredRows.length) {
      return null;
    }
    const sum = filteredRows.reduce((acc, row) => {
      let number = getValue(row);
      if (number) {
        number = convertNumber(number);
        return acc + number;
      }
      return acc;
    }, 0);
    const count = filteredRows.reduce((count, row) => {
      const number = getValue(row);
      return number ? count + 1 : count;
    }, 0);
    return (sum / (count || 1)).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  if (type === "intSum") {
    if (!filteredRows.length) {
      return null;
    }
    const sum = filteredRows.reduce((acc, row) => {
      let number = getValue(row);
      if (number) {
        number = parseInt(number, 10);
        if (!isNaN(number)) {
          return acc + number;
        }
      }
      return acc;
    }, 0);
    return sum;
  }

  return IntegratedSummary.defaultCalculator(type, filteredRows, getValue);
};

export { confTableSummaryMessages };
export default confTableSummaryCalculator;
